import React, { useState, useEffect } from 'react';
import { Typography, Button } from '@mui/material';
import './ProgressButton.css';

interface ProgressButtonProps {
    trainingStatus: string; // "in-progress" or "completed"
}

const ProgressButton = ({ trainingStatus }: ProgressButtonProps) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (trainingStatus === "IN_PROGRESS") {
            const interval = setInterval(() => {
                setProgress(prev => (prev < 100 ? prev + 1 : prev));
            }, 50); 
            return () => clearInterval(interval);
        } else if (trainingStatus === "COMPLETED") {
            setProgress(100); 
        }
    }, [trainingStatus]);

    return (
        <div className="progress-container">
            <Button className="button-progress">
                {/* Animated progress background */}
                <span
                    className={`${trainingStatus === "IN_PROGRESS" ? "animate-progress" : ""}`}
                    style={{ width: `${progress}%` }}
                ></span>
                {/* Button text */}
                <Typography className="progress-text">
                    {trainingStatus === "IN_PROGRESS" ? "In Progress...": 'In Progress'}
                </Typography>
            </Button>
        </div>
    );
};

export default ProgressButton;
